import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import { ItemsDesplegables } from './ItemsDesplegables';
import { ItemsPlanes } from './ItemsPlanes';

export const NavBar = () => {
    const { pathname } = useLocation();
    const [vehiculos, setvehiculos] = useState([]);
    const [concesionarioDropdownVisible, setConcesionarioDropdownVisible] = useState(false);
    const [urlConcesionarias, setUrlConcesionarias] = useState("");
    const dropdownRef = useRef(null); // Ref for dropdown container

    useEffect(() => {
        fetch("/modelos_planes_cuotas")
            .then((res) => res.json())
            .then((result) => {
                if (result.estado !== 0) {
                    setvehiculos(result);
                }
            });

        fetch("/get_url_concesionarios")
            .then((res) => res.json())
            .then((data) => {
                if (data && data.url) {
                    setUrlConcesionarias(data.url);
                }
            })
            .catch((error) => {
                console.error("Error fetching concesionarias URL:", error);
            });
    }, []);

    const [size, setSize] = useState(window.innerWidth);
    window.addEventListener("resize", () => {
        setSize(window.innerWidth);
    });

    const toggleDropdown = () => {
        setConcesionarioDropdownVisible((prev) => !prev);
    };

    const closeDropdown = () => {
        setConcesionarioDropdownVisible(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown(); // Close the dropdown if the click is outside
            }
        };

        document.addEventListener("mousedown", handleClickOutside); // Listen for mouse clicks
        return () => {
            document.removeEventListener("mousedown", handleClickOutside); // Clean up listener
        };
    }, []);

    useEffect(() => {
        let setFocus = (path, btn) => {
            if (pathname.includes(path)) {
                let button = document.querySelector(btn);

                if (button) {
                    button.classList.add("hoverFocus");
                }
            } else {
                let button = document.querySelector(btn);

                if (button) {
                    button.classList.remove("hoverFocus");
                }
            }
        };

        setFocus("acto_de_adjudicacion", ".actoBtn");
        setFocus("conoce_ram_plan", ".conoceBtn");
        setFocus("informacion_general", ".infoBtn");
        setFocus("planes", ".planesBtn");
        setFocus("planes", ".planesBtnMobile");

        let collapseDiv = document.querySelectorAll(".collapseDiv");
        let drodpdownFixed = (path) => {
            if (path === pathname) {
                if (size < 992) {
                    collapseDiv.forEach((collapse) => (collapse.style.top = "116px"));
                } else {
                    collapseDiv.forEach((collapse) => (collapse.style.top = "144px"));
                }
            }
        };

        let paths = ["/cuotas", "/inicio", "/mis_datos", "/notificaciones", "/instructivos"];
        let path = paths.filter((path) => path === pathname);
        if (path.length > 0) {
            drodpdownFixed(path[0]);
        } else {
            if (size < 992) {
                collapseDiv.forEach((collapse) => (collapse.style.top = "60px"));
            } else {
                collapseDiv.forEach((collapse) => (collapse.style.top = "90px"));
            }
        }
    }, [pathname]);

    // Los desplegables de Planes y de Suscribite muestran la misma grilla de modelos. El de
    // Suscribite agrega el hash que hace que la pantalla del plan scrollee hasta el formulario.
    const modelosDesplegable = (hash = "") =>
        vehiculos.length != 0 ? (
            vehiculos.map((veh, index) =>
                veh.Planes[0].some(plan => plan.visible) ? (
                    <Fragment key={veh.id}>
                        <ItemsPlanes link={"/planes/auto/" + veh.id + hash} name={veh.titulo} amount={veh.cuota_desde} img={veh.hash_foto} id={veh.id} pixelTags={veh.pixel_tags} />
                        {index + 1 != vehiculos.length && <div className="separator--hor mt-half mb-half"></div>}
                    </Fragment >
                ) : (
                    <></>
                )
            )
        ) : (
            <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                <p className="mt-2">Actualizando Planes, volver más tarde</p>
            </div>
        );

    return (
        <header>
            <nav className="nav">
                <div className="nav-container">
                    <div className="logo">
                        <Link to={"/"}>
                            <button>
                                <img src="/images/header/Ram-Plan_5.png" />
                            </button>
                        </Link>
                    </div>

                    <div className="ul-container">
                        <ul>
                            <li className="d-flex btn planesNav">
                                <button
                                    className="nav_button nav_button_desktop planesBtn"
                                    data-expandible="planes"
                                    role="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Planes
                                    <img className="ml-octa" src="/images/icons/arrow-white-down.svg" />
                                </button>
                            </li>
                            <li>
                                <Link to={"/conoce_ram_plan"}>
                                    <button className="conoceBtn">CONOCÉ RAM PLAN</button>
                                </Link>
                            </li>
                            <li>
                                <Link to={"/acto_de_adjudicacion"}>
                                    <button className="actoBtn">Acto de adjudicación</button>
                                </Link>
                            </li>
                            <li>
                                <Link to={"/informacion_general"}>
                                    <button className="infoBtn">Información general</button>
                                </Link>
                            </li>
                            <li ref={dropdownRef}>
                                <button
                                    onClick={toggleDropdown}
                                    className="nav_button nav_button_desktop"
                                    aria-haspopup="true"
                                    aria-expanded={concesionarioDropdownVisible}
                                >
                                    CONCESIONARIOS
                                </button>
                                {concesionarioDropdownVisible && (
                                    <ul className="concesionarioDropdown">
                                        <li>
                                            <a
                                                href={urlConcesionarias || "#"}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Concesionario más cercano
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="/concesionarios/listado"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Listado de concesionarios
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        </ul>
                        <div className="miplan order-sm-1">

                            <Link to={'/login_mi_plan'}>
                                <button>
                                    <p className="mb-0 text-center">Mi Plan</p>
                                </button>
                            </Link>
                        </div>
                        <div className="miplan order-sm-1">
                            <button
                                className="suscribiteBtn"
                                data-expandible="suscribite"
                                role="button"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <p className="mb-0 text-center">Suscribite</p>
                            </button>
                        </div>
                        <div className="ul-container--plan btn">
                            <button className="nav_button nav_button_desktop planesBtnMobile" data-expandible="planes"
                                // disabled={habilitar}
                                role="button" aria-haspopup="true" aria-expanded="false" >
                                Planes
                                <img className="ml-octa" src='/images/icons/arrow-white-down.svg' />
                            </button>

                        </div>
                        <div className="ul-container--mobile order-sm-3">
                            <button className="nav_button nav_button_desktop" data-expandible="menu" role="button" aria-haspopup="true" aria-expanded="false">
                                <img src='/images/icons/menu.svg' />
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            <div className="containerCollapse ">
                <div className="collapseDiv container-fluid container-fluid--main" data-expandible="planes">
                    <div className="collapseDiv--items collapseDiv--plan">
                        {modelosDesplegable()}
                    </div>
                </div>
                <div className="collapseDiv container-fluid container-fluid--main" data-expandible="suscribite">
                    <div className="collapseDiv--items collapseDiv--plan">
                        {modelosDesplegable("#mas_informacion")}
                    </div>
                </div>
                <div className="collapseDiv container-fluid container-fluid--main" data-expandible="menu">
                    <div className="collapseDiv--items d-flex flex-column">
                        <ItemsDesplegables url='/conoce_ram_plan' text="CONOCÉ RAM PLAN" />
                        <div className="separator--hor mt-half mb-half"></div>
                        <ItemsDesplegables url="/acto_de_adjudicacion" text="Acto de adjudicacion" />
                        <div className="separator--hor mt-half mb-half"></div>
                        <ItemsDesplegables url="/informacion_general" text="Información general" />
                        <div className="separator--hor mt-half mb-half"></div>
                        <a target="_blank" href='https://www.contactofca.com.ar/concesionarios/index.php?marca=j&_ga=2.210326611.717054605.1611262909-1902345954.1554387761' className="items-despegables">
                            <p>concesionarios</p>
                            <img className="ml-half" src="/images/icons/small.svg" />
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
};

